export default __webpack_public_path__ + "static/media/Golden Age of Private Credit.393455c9.pdf";